export default __webpack_public_path__ + "static/media/drr.61b1ccee.jpg";